import { render, staticRenderFns } from "./ValidacaoSelo.vue?vue&type=template&id=056c3e34&scoped=true"
import script from "./ValidacaoSelo.vue?vue&type=script&lang=js"
export * from "./ValidacaoSelo.vue?vue&type=script&lang=js"
import style0 from "./ValidacaoSelo.vue?vue&type=style&index=0&id=056c3e34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056c3e34",
  null
  
)

export default component.exports